import { Vehicle } from '@spike/vehicle-model';
import isEmpty from 'lodash/isEmpty';
import { FunctionComponent, useMemo } from 'react';
import styles from './VehicleDetailsStep.module.scss';
import BasicInfoSection from './Sections/BasicInfo/BasicInfoSection';
import PhotosSection from './Sections/Photos/PhotosSection';
import StepButton from '../../Shared/Button/StepButton';

interface VehicleDetailsStepProps {
    vehicle: Vehicle;
    nameError: string | null;
    className?: string;
    onChange?: (vehicle: Vehicle) => void;
    onSave?: () => void;
    saving?: boolean;
}

export const VehicleDetailsStep: FunctionComponent<VehicleDetailsStepProps> = props => {
    const disableSave = useMemo(() => isEmpty(props.vehicle.name) || props.vehicle.maxPets < 1, [props.vehicle]);

    const handleBasicInfoChange = (name: string, maxPets: number) => {
        props.onChange?.({ ...props.vehicle, name, maxPets });
    };

    const handlePhotosChange = (photos: Vehicle['photos']) => {
        props.onChange?.({ ...props.vehicle, photos });
    };

    return (
        <div className={styles.container}>
            <BasicInfoSection
                name={props.vehicle.name}
                maxPets={props.vehicle.maxPets}
                nameError={props.nameError}
                onChange={handleBasicInfoChange}
            />

            <PhotosSection
                photos={props.vehicle.photos}
                onChange={handlePhotosChange}
            />

            <StepButton
                label={props.saving ? 'Saving...' : 'Save Vehicle'}
                disabled={disableSave || props.saving}
                loading={props.saving}
                onClick={props.onSave}
            />
        </div>
    );
};

export default VehicleDetailsStep;
